import { useEffect, type JSX } from 'react'
import { useSearchParams } from 'react-router'

/**
 * This page is loaded inside the OAuth popup after the provider redirects back.
 * It posts the result to the opener and closes itself.
 */
export default function EmailOAuthCallback(): JSX.Element {
  const [searchParams] = useSearchParams()

  const provider = searchParams.get('provider') === 'microsoft' ? 'microsoft' : 'google'
  const channel = searchParams.get('channel') === 'outbound' ? 'outbound' : 'inbound'
  const configId = searchParams.get('configId') ?? ''

  useEffect(() => {
    if (!configId) return

    const payload = {
      type: 'email-oauth-success' as const,
      provider,
      channel,
      configId,
    }

    try {
      if (window.opener) {
        window.opener.postMessage(payload, '*')
      }
    } catch {
      // Ignore cross-origin postMessage errors
    }

    // Close the popup after a short delay so the postMessage can be delivered.
    const timer = setTimeout(() => window.close(), 50)
    return () => clearTimeout(timer)
  }, [provider, channel, configId])

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif', textAlign: 'center' }}>
      <h1>Authentication complete</h1>
      <p>You can close this window.</p>
      <button type="button" onClick={() => window.close()}>
        Close window
      </button>
    </div>
  )
}
